// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.total{
  padding: 1em;
  border-radius: 3px;
  background-color: rgb(200, 255, 255);
  border-radius: .5em;
}

.total__p{
  font-size: 1em;
  color: rgb(72, 77, 77);
}

.total > button:active{
  background-color: unset;
  border: 1px solid #FFD814;
}

.shipping {
  color: green;
  font-weight: bold;
}

.total h4 {
  font-size: 1em;
  font-weight: 450;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/total.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".total{\n  padding: 1em;\n  border-radius: 3px;\n  background-color: rgb(200, 255, 255);\n  border-radius: .5em;\n}\n\n.total__p{\n  font-size: 1em;\n  color: rgb(72, 77, 77);\n}\n\n.total > button:active{\n  background-color: unset;\n  border: 1px solid #FFD814;\n}\n\n.shipping {\n  color: green;\n  font-weight: bold;\n}\n\n.total h4 {\n  font-size: 1em;\n  font-weight: 450;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
